import { cn } from "@gymflow/helpers";
import { ReactNode } from "react";

import CustomTooltip from "../CustomTooltip";

type RadioButtonProps<T extends string | number> = {
  value: T;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  name?: string;
  label?: ReactNode;
  disabled?: boolean;
  containerClassName?: string;
  labelClassName?: string;
  disabledTooltip?: string;
};

export const RadioButton = <T extends string | number>({
  checked,
  label,
  disabled,
  disabledTooltip,
  containerClassName,
  labelClassName,
  ...rest
}: RadioButtonProps<T>) => (
  <div
    className={cn(
      "flex items-center gap-3",
      {
        "cursor-not-allowed": disabled,
      },
      containerClassName,
    )}
  >
    <div className="relative size-5">
      <CustomTooltip asChild message={disabled ? disabledTooltip : undefined}>
        <input
          type="radio"
          checked={checked}
          className="size-5 cursor-pointer"
          readOnly={disabled}
          disabled={disabled}
          {...rest}
        />
      </CustomTooltip>
      <div
        className={cn(
          "pointer-events-none absolute left-0 top-0 flex h-5 w-5 items-center justify-center rounded-full transition-all",
          checked ? "bg-secondary-500" : "bg-gray-300",
        )}
      >
        <div
          className={cn(
            "rounded-full bg-gray-0 transition-all",
            checked ? "h-2 w-2" : "h-[1.125rem] w-[1.125rem]",
          )}
        />
      </div>
    </div>
    {label && (
      <div
        className={cn(
          "dark:text-gray-0 m-0 block select-none text-base font-medium text-gray-950",
          labelClassName,
        )}
      >
        {label}
      </div>
    )}
  </div>
);
